export const LogoMark = ({ size = 36 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
  >
    <rect width="64" height="64" rx="14" fill="#0B0C0E" />
    <rect x="1" y="1" width="62" height="62" rx="13" fill="none" stroke="#FF9900" strokeOpacity="0.35" strokeWidth="2" />
    <path d="M20 45V19h11a9 9 0 0 1 0 18h-7l11 8" fill="none" stroke="#FF9900" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M40 45l5-4-5-2" fill="none" stroke="#FF9900" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const LogoWordmark = () => (
  <span className="font-display font-extrabold tracking-tight text-lg leading-none select-none">
    RS<span className="text-[#FF9900]">—</span>LDH
  </span>
);
